'use client';

import React, { useState, useEffect } from 'react';
import { Bell, Search, Zap, ChevronDown } from 'lucide-react';

interface AppUser {
  name: string;
  initials: string;
  role: string;
  email: string;
}

export default function Topbar() {
  const [searchFocused, setSearchFocused] = useState(false);
  const [user, setUser] = useState<AppUser>({ name: 'Marcus Allen', initials: 'MA', role: 'Admin', email: '' });

  useEffect(() => {
    try {
      const stored = localStorage.getItem('appnest_user');
      if (stored) {
        const parsed = JSON.parse(stored) as AppUser;
        setUser(parsed);
      }
    } catch {
      // keep default
    }
  }, []);

  return (
    <header className="h-16 bg-card border-b border-border flex items-center px-6 gap-4 sticky top-0 z-20"
      style={{ background: 'linear-gradient(180deg, #ffffff 0%, #faf8ff 100%)' }}>
      {/* Search */}
      <div className={`flex items-center gap-2 px-3 py-2 rounded-xl border transition-all duration-200 flex-1 max-w-md ${
        searchFocused
          ? 'border-primary bg-card shadow-md'
          : 'border-border bg-muted/60'
      }`}
        style={searchFocused ? { boxShadow: '0 0 0 3px rgba(91,53,232,0.12)' } : {}}>
        <Search size={16} className="text-muted-foreground flex-shrink-0" />
        <input
          type="text"
          placeholder="Search campaigns, subscribers…"
          className="bg-transparent text-sm text-foreground placeholder:text-muted-foreground outline-none w-full"
          onFocus={() => setSearchFocused(true)}
          onBlur={() => setSearchFocused(false)}
        />
        <kbd className="hidden sm:inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium text-muted-foreground bg-border">
          ⌘K
        </kbd>
      </div>

      <div className="flex-1" />

      {/* Upgrade badge */}
      <button
        className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold text-white transition-all duration-150 hover:opacity-90 active:scale-95"
        style={{ background: 'linear-gradient(135deg, #5b35e8 0%, #8b5cf6 60%, #ff5c2b 100%)', boxShadow: '0 2px 10px rgba(91,53,232,0.3)' }}
      >
        <Zap size={12} />
        Upgrade Plan
      </button>

      {/* Notifications */}
      <button className="relative w-9 h-9 rounded-xl flex items-center justify-center hover:bg-muted transition-all duration-150">
        <Bell size={18} className="text-muted-foreground" />
        <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full"
          style={{ background: 'linear-gradient(135deg, #ff5c2b, #ff8c5a)' }} />
      </button>

      {/* User */}
      <button className="flex items-center gap-2 px-2 py-1.5 rounded-xl hover:bg-muted transition-all duration-150">
        <div className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-bold"
          style={{ background: 'linear-gradient(135deg, #5b35e8, #ff5c2b)' }}>
          {user.initials}
        </div>
        <span className="hidden sm:block text-sm font-medium text-foreground">{user.name}</span>
        <ChevronDown size={14} className="text-muted-foreground" />
      </button>
    </header>
  );
}